<template>
  <div>
    <div class="page-title">Edit Role</div>
    <Form
      v-if="form"
      v-model="form"
      :submit="update"
      btnText="Update Role"
      action="edit"
      @destroy="destroy"
    />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.participant-role.page";
export default {
  components: { Form },
  metaInfo() {
    const subject = this.form?.title;
    return {
      title: subject ? `Edit “${subject}” Role` : `Edit Role`,
    };
  },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async destroy() {
      await this.$api.Role.destroy({ id: this.$route.params.id });
      this.$router.push("/users/participants");
    },
    async setForm() {
      const { data } = await this.$api.Role.get({ id: this.$route.params.id });
      this.form = data;
    },
    async update() {
      await this.$api.Role.update(this.form);
      this.$router.push("/users/participants");
    },
  },
};
</script>

<style></style>
